import {type} from './typography';

/**
 * Opt-in line heights (DIS-1844) for the four text styles that Figma "Loyalty Sign-Up
 * Redesign" (file JNExbbbe4KI568IdRlm8Rh) specifies: Heading/H1 and Button/Category at
 * 1.0, Paragraph/P1 and Paragraph/P2 at 1.06. Letter spacing is 0 on all four, which
 * is the platform default, so no letterSpacing token exists.
 *
 * Kept out of `type.*` on purpose: adding lineHeight there would re-render every
 * existing consumer. The DIS-1737 guard test still forbids it on `type.*`. Spread it
 * next to the type token: `[type.paragraph.p2, lineHeight.paragraph.p2]`.
 *
 * React Native takes lineHeight in px, so each value is fontSize × the Figma ratio.
 */
const px = (fontSize: number | undefined, ratio: number) =>
  Object.freeze({lineHeight: Math.round((fontSize ?? 0) * ratio * 100) / 100});

export const lineHeight = Object.freeze({
  heading: Object.freeze({h1: px(type.heading.h1.fontSize, 1)}),
  paragraph: Object.freeze({
    p1: px(type.paragraph.p1.fontSize, 1.06),
    p2: px(type.paragraph.p2.fontSize, 1.06),
  }),
  button: Object.freeze({category: px(type.button.category.fontSize, 1)}),
});
